import React from 'react';

import { useNavigate } from 'react-router-dom';

import { CardsCategories } from '../../components/CardsCategories';
import { Tag } from '../../components/Tag';
import EmbeddedVideo from '../EmbeddedVideo/EmbeddedVideo';
import './style.css';

import Hyphenated from 'react-hyphen';
import de from 'hyphenated-de';

import DateUtils from '../../utils/DateUtils';

const FAQPreviewBox = ({
    element,
    i,
    shouldCenter,
    shouldMaxHeight,
    showDate,
    height,
    minWidth,
}) => {
    const navigate = useNavigate();

    let cardDescription = '';
    if (
        null != element.sections &&
        0 < element.sections.length &&
        null != element.sections[0].text
    ) {
        let textNoHtml = stripHtml(element.sections[0].text);

        let maxLength = 150 > textNoHtml.length ? textNoHtml.length : 150;

        cardDescription = textNoHtml.substring(0, maxLength);
    }

    let cardStyle = shouldCenter ? { margin: 'auto' } : { margin: 'inherit' };

    if (null != height) {
        cardStyle.height = height;
    }

    if (null != minWidth) {
        cardStyle['min-width'] = minWidth;
    }

    if (shouldMaxHeight) {
        cardStyle.height = '100%';
    }

    // console.log('element', element)

    return (
        <div key={'preview-box-' + i} className="card" style={cardStyle}>
            <div className="content-9">
                <div className="header-2">
                    <div className="details">
                        <div className="card-datum">
                            <div className="datum">
                                {showDate ? (
                                    <div className="datum-2">
                                        {DateUtils.formatTimestamp(
                                            element.dateCreation,
                                        )}
                                    </div>
                                ) : null}
                            </div>
                        </div>

                        {buildAuthoringList(i, element.authors)}
                    </div>

                    <Tag
                        className="tag-instance"
                        size="small"
                        stateProp="default"
                        style="featured"
                        text={element.resourceType.name}
                        isClickable={false}
                    />
                </div>

                <div className="div-16"  style={{paddingTop: "25%"}}>

					{"TITLE_MEDIA_TYPE_VIDEO" == element.titleMediaType ? <EmbeddedVideo src={element.titleVideo} isThumbnail={true}/> : 

                    	<div className="image-10" style={{ cursor: 'pointer', backgroundImage: 'url(' + element.titleImage + ')' }}
                        	onClick={() => {
								let url = element.isVideoFAQItem ? '/faq' : '/singleMaterial'
                            	navigate(url + '/' + element.id);
						}}/>
					}					
					
										
                </div>

                <div className="div-16" style={{paddingTop: "15%"}}>
                    <div
                        className="heading-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            let url = element.isVideoFAQItem ? '/faq' : '/singleMaterial'
                            navigate(url + '/' + element.id);
                        }}
                    >
                        <Hyphenated
                            language={de}
                            style={{ lineBreak: 'anywhere' }}
                        >
                            {element.title}
                        </Hyphenated>
                    </div>

                    <p
                        className="excerpt"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            let url = element.isVideoFAQItem ? '/faq' : '/singleMaterial'
                            navigate(url + '/' + element.id);
                        }}
                    >
                        {cardDescription}
                    </p>
                </div>

                {element.isVideoFAQItem ? null : <CardsCategories element={element} /> }

                {/* <div className="categories">
                        <Tag className="tag-instance" size="small" stateProp="default" style="default" text={element.mediaUsageGoal.goal} isClickable={false}/>
                        
              {null == element.subjectMatterCategories ? null : element.subjectMatterCategories.map((cat, i) => {
                return <Tag className="tag-instance" size="small" stateProp="default" style="default" text={cat.category} isClickable={false}/>;
              })}
              
              {null == element.schoolTypes ? null : element.schoolTypes.map((schoolType, i) => {
                return <Tag className="tag-instance" size="small" stateProp="default" style="default" text={schoolType.name} isClickable={false}/>;
              })}
                      </div> */}
            </div>
        </div>
    );

    function buildAuthoringList(i, authors) {
        if (null == authors) {
            return null;
        }
        // offer this solution in question of rezining box
        else if (2 >= authors.length) {
            return (
                <div className="div-wrapper-2">
                    <div className="author-name">
                        {authors
                            .map(
                                (author) =>
                                    author.firstName + ' ' + author.lastName,
                            )
                            .join(', ')}
                    </div>
                </div>
            );
        } else {
            let author = authors[0];
            return (
                <div className="div-wrapper-2">
                    <div key={'author-' + i + '-' + 0} className="author-name">
                        {author.firstName + ' ' + author.lastName + ' et al.'}
                    </div>
                </div>
            );
        }
    }

    function stripHtml(html) {
        let tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        let tagFreeText = tmp.textContent || tmp.innerText || '';

        tmp.remove();

        return tagFreeText;
    }
};

export default FAQPreviewBox;
